import React from 'react';
import { Modal, Form, Input, Row, Col } from 'antd';
import useApi from '../../hooks/useApi';

const { TextArea } = Input;

const ModalAdd = ({ visible, onCancel, onConfirm }) => {
  const [form] = Form.useForm();

  const { callApi: addGrupo } = useApi('https://vision.alfama.com/api/add/grupos_permissao', {
    method: 'POST',
    includeToken: true,
    successMessage: 'Grupo adicionado com sucesso!',
    errorMessage: 'Erro ao adicionar grupo'
  });

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      await addGrupo(values);
      form.resetFields();
      onConfirm(true);
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('Erro ao adicionar grupo:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Adicionar Grupo"
      open={visible}
      onCancel={handleCancel}
      onOk={handleConfirm}
      okText="Adicionar"
      cancelText="Cancelar"
      maskClosable={false}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="nome"
              label="Nome"
              rules={[{ required: true, message: 'Por favor, insira o nome do grupo' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="codigo"
              label="Código RLS"
              rules={[
                { required: true, message: 'Por favor, insira o código do grupo' }
              ]}
              tooltip="O codigo será utilizado em dashboards que precisam de regras RLS"
            >
              <Input 

                placeholder="EX1234-DEPARTAMENTO"
                
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="descricao"
              label="Descrição"
              rules={[{ required: true, message: 'Por favor, insira a descrição do grupo' }]}
            >
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalAdd;